import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;


export const getConceirgeListing = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/conceirge`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getUsersByConceirge = async (query, role, id) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/conceirge/role/${role}/user/${id}?${query}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}